import React, { useState, useEffect, useContext} from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { styled, ThemeProvider } from '@mui/material/styles';
import Carousel, {Modal, ModalGateway} from 'react-images';

// material
import { Container, Grid, Card, Box, Stack, Button, Typography, CardActionArea } from '@mui/material';

import {api, reiniciarToken, consImagensProduto} from '../../../services/api';
// context
import { AuthContext } from '../../../contexts/auth';  

import Iconify from '../../../components/Iconify';
import Page from '../../../components/Page';
import Theme from '../../../components/Button';

export default function ConsultaImagensProduto() {
  
  const {id} = useParams(); 
  const { logout } = useContext(AuthContext);
  const [dados, setData] = useState([]);
  const [currentImage, setCurrentImage] = useState(0);
  const [viewrIsOpen, setViewrsIsOpen] = useState(false);

  const getImagens = async () => {
    
    const retorno = await reiniciarToken();
    if(retorno.erro === true) {
      if (retorno.mensagem === 'O Token é inválido!' || retorno.mensagem === 'Acesso negado!'){
        logout();
      }
    }else{
      localStorage.setItem("token", retorno.data.token);
      api.defaults.headers.Authorization = `Bearer ${retorno.data.token}`;
    }

    const response = await consImagensProduto(id);
    if(response.erro === true) {
      if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      response.data.forEach((valores) => {
        setData(dados => [...dados, {src: valores.url, id_imagem_produto: valores.id_imagem_produto}])
      }); 
      // setData(response.data)
    }
  }

  useEffect(() => {
    getImagens();
  },[]) 

  const ProductImgStyle = styled('img')({
    top: 0,
    width: '100%',
    height: '100%',
    position: 'absolute',
  });

  const openLightbox = (index) => {
    console.log(index)
    setCurrentImage(index);
    setViewrsIsOpen(true);
  };

  const closeLightBox = () => {
    setCurrentImage(0);
    setViewrsIsOpen(false);
  }
          
  return (
    <Page title="Imagens Produto">
      <Container>   
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Lista de Imagens
            </Typography>

            <ThemeProvider theme={Theme}>
                <Button variant="contained" color="neutral" component={RouterLink} to="/produto/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                  Voltar
                </Button>
            </ThemeProvider>
          </Stack>
          <Grid container spacing={3}>
              {dados.sort((a,b) => a.id - b.id).map((product, i) => (
                  <Grid key={product.id_imagem_produto} item xs={12} sm={6} md={3}>
                      <CardActionArea>
                        <Card onClick={() => openLightbox(i)}>
                            <Box sx={{ pt: '100%', position: 'relative' }}>
                                <ProductImgStyle src={product.src} />
                            </Box>
                        </Card> 
                      </CardActionArea>
                  </Grid> 
              ))}
              <ModalGateway>
                {viewrIsOpen ? (
                  <Modal 
                    sx={{display: 'flex',
                        p:1,
                        alignItems: 'center',
                        justifyContent: 'center'}}
                    onClose={closeLightBox}>
                    <Carousel
                      currentIndex={currentImage}
                      views={dados.map(x => ({
                        ...x, srcset: x.srcSet, caption: x.title
                      }))}
                    />
                  </Modal>
                ): null}
              </ModalGateway>
          </Grid>
      </Container>
    </Page>  
  );
}